import loadScript from "load-script";
import React, { useCallback, useEffect } from "react";
import Broadcast from "./components/header/Broadcast";
import LoginArea from "./components/header/LoginArea/LoginArea";
import ServiceMenu from "./components/header/ServiceMenu";
import NotificationBarWrapper from "./components/header/LoginArea/NotificationBarWrapper";
import { AFREECATV_URL, POINT_URL } from "./constants/config";
import { LOGIN_URL } from "./constants/config";
import { Trans, useTranslation } from "react-i18next";
import { useAuth } from "./contexts/AuthProvider";
var Notice = React.lazy(function () {
  return import("./components/header/Notice");
});
export default function GNB() {
  var lang = document.documentElement.lang;
  var t = useTranslation().t;

  var _a = useAuth(),
      isLogin = _a.isLogin,
      userNick = _a.userNick,
      userId = _a.userId,
      noteNew = _a.noteNew;

  useEffect(function () {
    /**
     * 검색 붙이기
     */
    loadScript("//static.onlive.vn/asset/app/search/dist/umd/index.js", {
      attrs: {
        class: "searchBox",
        "data-type": "total",
        "data-location": "my_main"
      }
    });
  }, []);
  /**
   * 로그인
   */

  var handleGoLogin = useCallback(function (event) {
    window.location.href = LOGIN_URL + "/afreeca/login.php?szFrom=full&request_uri=" + window.encodeURIComponent(window.location.href);
    event.preventEvent();
  }, []);
  return React.createElement("header", {
    id: "serviceHeader"
  }, React.createElement("div", {
    className: "innerHeader",
    id: "topInnerHeader"
  }, React.createElement("h1", {
    id: "afLogo"
  }, React.createElement("a", {
    href: AFREECATV_URL
  }, "OnLive")), React.createElement("em", null, React.createElement("div", {
    className: "serviceUtil"
  }, React.createElement(Broadcast, null), React.createElement("div", null, React.createElement("a", {
    href: POINT_URL,
    target: "_blank",
    type: "button",
    className: "btn-buy-balloon"
  }, React.createElement("span", null, "Mua B\xF3ng"))), React.createElement(NotificationBarWrapper, null), !isLogin && React.createElement("button", {
    type: "button",
    className: "btn-login",
    onClick: handleGoLogin
  }, React.createElement(Trans, null, "\uB85C\uADF8\uC778")), React.createElement(LoginArea, null), React.createElement(ServiceMenu, null)))));
}